import React, { useEffect } from "react";

import logger from "../../../utils/LoggerFrontend";
import CampaignCreatePreviews from "./campaign-create-previews/CampaignCreatePreviews.jsx";
import Actions from "../../../Actions";
import { withRefluxStore, PreviewStore, MediaAssetsLabStore } from "../../../Stores";

import { HeaderWrapper, Title, Description } from "./Components/TextSections.jsx";
import { InfoBanner } from "./Components/";
import { useTranslation } from "react-i18next";
import { CampaignContextProvider } from "../../../context/Campaign.context.jsx";
import { getLanguageFromLocale } from "../QualificationQuestions/utils.js";

const CampaignCreatePreviewsStep = ({
  orgaId,
  userId,
  userName,
  // PreviewStore
  loading,
  loadingTeaserOptions,
  campaignData,
  //MediaAssetsLabStore
  showMediaAssetsLabModal,
  // Props
  selectedChannels,
  linkedInPageId,
  sentences,
  locale,
  // States for the next sidebar
  jobTitle = "",
  location = [],
  jobPostingUrl = "",
  companyName = "",
  companyId = "",
  orgaName = "",
  jobCategoryId = "generic",
  children = [],
  campaignId,
  organization
}) => {
  const { t } = useTranslation();

  const campaignLanguage = getLanguageFromLocale(locale || campaignData?.locale || "de_DE");

  useEffect(() => {
    if (!loading && !loadingTeaserOptions) {
      logger.log("CampaignCreatePreviewsStep:useEffect", "called", {
        loading,
        loadingTeaserOptions
      });

      if (companyId) {
        Actions.getBrandKitByCompanyId(companyId);
        const brandkitSuccessfully = Actions.getBrandKitByCompanyId.completed.listen((result) => {
          const { payload } = result;
          const companyBrandkit = payload;

          // Load the posts (could be a draft)
          Actions.initPosts({
            jobPostingUrl,
            jobTitle,
            companyName,
            companyId,
            orgaName,
            orgaId,
            userId,
            userName,
            jobCategoryId,
            selectedChannels,
            location,
            shouldAutoGenerateCampaignText: Boolean(organization?.shouldAutoGenerateCampaignText),
            brandKit: companyBrandkit,
            sentences,
            campaignLanguage
          });

          Actions.getLastLinkedInAdCreativesByCompanyAndOrgaId(companyName, orgaId);
          brandkitSuccessfully();
        });
      } else {
        logger.log("error:CampaignCreatePreviewsStep:useEffect", "companyId is not set", {
          companyId,
          companyName,
          orgaId,
          orgaName
        });
      }
    }
  }, [
    loadingTeaserOptions,
    loading,
    orgaName,
    orgaId,
    userId,
    userName,
    companyName,
    jobPostingUrl,
    jobTitle,
    selectedChannels,
    jobCategoryId,
    location,
    campaignId,
    organization?.shouldAutoGenerateCampaignText,
    companyId,
    campaignLanguage
  ]);

  logger.log("CampaignCreatePreviewsStep:render", "called...", {
    selectedChannels,
    loading
  });

  const lastCompanyAdCreativeLinkedInPageId = linkedInPageId ?? null;

  const orgaLinkedInPageID = organization?.linkedInPageId || lastCompanyAdCreativeLinkedInPageId;

  const linkedInCompanyId = organization?.isAgency
    ? lastCompanyAdCreativeLinkedInPageId
    : orgaLinkedInPageID;

  return (
    <CampaignContextProvider>
      {!showMediaAssetsLabModal && (
        <>
          <InfoBanner status="booking" />
          <HeaderWrapper>
            <Title>{t("Ad Preview")}</Title>
            <Description>
              {t("This is what your ad will look like on the different platforms.")}
            </Description>
          </HeaderWrapper>
        </>
      )}
      <CampaignCreatePreviews
        orgaId={orgaId}
        tbCampaignId={campaignId}
        orgaLinkedInPageID={linkedInCompanyId}
        selectedChannels={selectedChannels}
      />
      {children}
    </CampaignContextProvider>
  );
};

export default withRefluxStore(
  CampaignCreatePreviewsStep,
  [PreviewStore, MediaAssetsLabStore],
  [
    "posts",
    "channelsData",
    "loading",
    "loadingTeaserOptions",
    "linkedInPageId",
    "showMediaAssetsLabModal",
    "campaignData"
  ]
);
